/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { homeRedirectRoute } from '@jira/router-routes__home-redirect-routes/src/homeRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import JiraBaseRedirect from './common/ui/redirect/jira-base-redirect/index.tsx';

export const homeRedirectRouteEntry: Route = createEntry(homeRedirectRoute, () => ({
	group: 'home',
	// eslint-disable-next-line no-restricted-syntax
	component: JiraBaseRedirect,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	isRedirect: true,
	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
